if (!customElements.get('product-form')) {

  //define variant selected as flase
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form){
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      const updateCartElements = (response)=>{
        $('.product-form__submit_mobile').html('Add to cart').removeClass('disabled');

        if ($(window).width() >= 768 && response) {
          this.cartNotification.renderContents(response);
        } else if(response) {
          $(".added-to-cart-success").removeClass('hidden');
          $(".added-to-cart-success").show();
          setTimeout(function (e) {
            $(".added-to-cart-success").fadeOut();
          }, 1000);
          jQuery.getJSON('/cart.js', function (cart) {
            $("#mob_cart_count").html(cart.item_count);
            $("#mob_cart_count").removeClass('hidden');
          });
        }
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');

      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      $('.product-form__submit_mobile').html('Adding...').addClass('disabled');

      let addItemToCart = true;
      if(window.replaceFlashSaleItem == true){
        addItemToCart = await flashSaleReplace();
      }
      if(!addItemToCart){
        updateCartElements(null);
        return false;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if ($('product-form button[type="submit"]').hasClass('is-flash-sale')) {
            window.flashSaleItemId = formData.get('id');
          }
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
         updateCartElements(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
         // updateCartElements(response);
        });
    }

    handleErrorMessage(errorMessage = false) {

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        $('.addmore-cart-footer .added-to-cart-error').html(errorMessage);
        $(".addmore-cart-footer .added-to-cart-error").removeClass('hidden');
        $(".addmore-cart-footer .added-to-cart-error").show();
        setTimeout(function(e){
          $(".addmore-cart-footer .added-to-cart-error").fadeOut();
        },4000);
      }
    }
  });

  const flashSaleReplace = async ()=>{
    //if same product show warning
    const currentVariantId =  $("product-form").find('input[name="id"]').val();
    if(currentVariantId.toString() === window.flashSaleItemId.toString()){
      toggleFlashSaleWarningModal(); //only one item allowed
      return false
    }

    let updates = {}
    updates[window.flashSaleItemId] = 0;
   const update = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    }).then(data=>{
     
      const exists = data.items.some(item => item.id.toString() === window.flashSaleItemId.toString() );
      if(!exists){
        return true;
      }
      else {
        return false;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return update;
  }

    popup_cart_options = [];
    if(typeof popup_cart_options_values != 'undefined'){
      popup_cart_options = popup_cart_options_values.map(function(option){
        if(option.values.length >1){
          return option.name;
        }else{
          return null;
        }
      });
    }
    popup_cart_options = popup_cart_options.filter(function (el) {
      return el != null;
    });

    popup_cart_options.forEach( function(option){
     // $(".product-form__input input[type='radio'][name='"+option+"']").prop('checked', false);
      $(".product-form__input input[type='radio'][name='"+option.trim().replace(" ","_")+"']").removeAttr('checked');
      $(".product-form__input input[type='radio'][name='mob-"+option.trim().replace(" ","_")+"']").removeAttr('checked');
      
    });

    $(document).on("click", ".popup_option input[type='radio'], #color_variant_mobile input[type='radio']", function(e){
      let value = $(this).val();
      let option = $(this).attr('name'); // size, color
      let to_remove = $(this).attr('data-option');
      remove_popup_options(to_remove);
      hide_variant_alert();
      if(value != $(".variant-holder input[name="+option.trim().replace(" ","_")+"]:checked").val()){
        $(".variant-holder input[name="+option.trim().replace(" ","_")+"][value='"+value+"']").prop("checked",true);
        $(".variant-holder input[name=mob-"+option.trim().replace(" ","_")+"][value='"+value+"']").prop("checked",true);   
      }
      if(!popup_cart_options.length){
        document.querySelector('variant-radios').dispatchEvent(new Event("change"));
      } 
      // add selection to mobile color varaint
      if( option == "Color"){
        $("#color_variant_mobile .colorVariant input[name="+option.trim().replace(" ","_")+"][value='"+value+"']").prop("checked",true);
        $("#color_variant_mobile .form__label .selected-color").html(': '+ value);
      }

    });

    
    $(document).on('click','.variant-holder input[type="radio"]',function(e){
      let value = $(this).val();
      let option = $(this).attr('name'); // size, color
      let to_remove = $(this).attr('data-option');
      remove_popup_options(to_remove);
      if(value != $(".popup_option input[name="+option.trim().replace(" ","_")+"]:checked").val()){
       $(".popup_option input[name="+option.trim().replace(" ","_")+"][value='"+value+"']").prop("checked",true);
      }
    });
    
    $('.popup-add-to-cart').click(function(e){

      window.show_cart_popup_again = true;
      if(!popup_cart_options.length){
        toggleModalCart();
        document.querySelector('product-form form').dispatchEvent(new Event("submit"));
      }
      else{
        show_variant_alert();
      }
    });

    $('.popup-buy-now').click(function(e){
      if(!popup_cart_options.length){
        $(this).attr('disabled', 'disabled');
        $('.shopify-payment-button__button').trigger('click');
      }
      else{
        show_variant_alert();
      }
    });

    function remove_popup_options(option){
      window.show_cart_popup_again = false;
      if(popup_cart_options.includes(option)){ // remove option from array
        for( var i = 0; i < popup_cart_options.length; i++){ 
          if ( popup_cart_options[i] === option) { 
            popup_cart_options.splice(i, 1); 
              i--; 
          }
        }
      }
    }
    
    $('.cart_popup_qnty_input').change(function (e) { 
      let val = $(this).val();
      if( val != $('.pdp_qnty_input').val()){
        $('.pdp_qnty_input').val(val);
      }
    });
    
    $('.pdp_qnty_input').change(function (e) { 
      let val = $(this).val();
      if( val != $('.cart_popup_qnty_input').val()){
        $('.cart_popup_qnty_input').val(val);
      }
    });

    $('button.product-form__submit').click(function (e) {

      if(window.flashSaleItemId && window.isFlashSale &&  window.flashSaleAlertShow !== true){
        e.preventDefault();
        flashSaleValidate();//replace set to true
        return
      }

      if(popup_cart_options.length > 0){
        e.preventDefault();
        show_variant_alert_desktop();
        return
      }

    });

    $('.product-form__submit_buy_now').click(function (e) {
      if(popup_cart_options.length > 0){
        e.preventDefault();
        show_variant_alert_desktop();
      }
      else{
        $('.shopify-payment-button__button').trigger('click');
      }
    });

    const flashSaleValidate = ()=>{
      toggleFlashSaleconfirmModal();//ask to replace item
      return true;
    }

    $("#color_variant_mobile fieldset label").click(function (e) {
      $(this).siblings('input[type="radio"]').prop('checked', true);
    });

    if( $(window).width() < 993){

      $("#color_varaint_holder").hide();
      $("#color_variant_mobile .colorVariant .varient-wrap").click(function () {
        let selected_color = $(this).find('.selected-color').html();
        $("#color_variant_mobile .form__label .selected-color").html(': '+selected_color);
        //check correspodning color
      });
      if(!popup_cart_options.includes('Color')){
       let selected_color =  $("#color_variant_mobile .colorVariant .varient-wrap .selected-color").html();//default selected color for single varianyt
        $("#color_variant_mobile .form__label .selected-color").html(': '+selected_color);
      }
    }

    $(".varient-wrap label").click(function(e){
      let slide_item  = $(this).attr('for');
      $("#"+slide_item).show();
    });

    $(".share-wishlist_wrap .wishlist").click(function(e){
      e.preventDefault();
      $("#ZooomyList input").trigger("click");
    });

    $(".share-wishlist_wrap .share-wrap").click(function(e){
      e.preventDefault();
      $(".share-button__button").trigger('click');
    });

    $(".share-wishlist_wrap .wishlist.customer").click(function(e){
      $(this).toggleClass('checked');
    });

    const ZooomyList = setInterval(is_on_wishlist, 500);
    function is_on_wishlist() {
      let input = $("#ZooomyList input[type=checkbox]");
      if(input){
       if(input.prop("checked")){
        $(".share-wishlist_wrap .wishlist").addClass('checked');
       }
       clearInterval(ZooomyList);
      }
    }

    if($("h1.product__title span").width() >= $("h1.product__title").width()){
      $("h1.product__title").addClass('over-flow');
    }else{
      $("h1.product__title").removeClass('over-flow');
    }
    if(typeof popup_cart_options_values != 'undefined' &&  !single_varaint_product_outofstock){
      $('.product-form .product-form__submit span').html('Add To Cart');
      $('.product-form .product-form__submit').prop('disabled', false);
      $('.product-form .product-form__submit_buy_now').html('Buy Now').prop('disabled', false);
    }
   $("fieldset label").click(function(){
    $("button.thumbnail").removeAttr('aria-current');
   });
    
    function hide_variant_alert(){
      $(".select-alert").html('');
    }
    
    function show_variant_alert_desktop(){

      if( $(window).scrollTop() > $('h1.product__title').offset().top + 30){
        $('html, body').animate({
          scrollTop: $('h1.product__title').offset().top - 120
        }, 100);
      }

      $(".variant-select-alert").html('');
      popup_cart_options.map(function(option, index){
        
        $("."+option.trim().replace(" ","_")+"-select-alert").html('Please Select a '+option);
      });
      $(".variant-select-alert").css('display', 'block');
      setTimeout(function(e){
        $(".variant-select-alert").fadeOut();
      },3000)

    }

    function show_variant_alert(){
      $(".select-alert").html('');
      if(popup_cart_options.length == 1){
        $(".select-alert").html('Please select a '+popup_cart_options[0]);
      }
      else if (popup_cart_options.length == 2){
        $(".select-alert").html('Please select '+popup_cart_options[0]+' and '+popup_cart_options[1]);
      }
      else if (popup_cart_options.length > 2){
        $(".select-alert").html('Please select '+popup_cart_options.toString());
      }
      $(".select-alert").css('display', 'block');
      setTimeout(function(e){
        $(".select-alert").fadeOut();
      },3000)
    }
    
    $('.product-form__submit_mobile').click(function(e){

      if(window.flashSaleItemId && window.isFlashSale &&  window.flashSaleAlertShow !== true){
        e.preventDefault();
        flashSaleValidate();//replace set to true
        window.showVaraintPopup = true;
        return
      }
     
      if( window.show_cart_popup_again || popup_cart_options.length  ){
        e.preventDefault();
        toggleModalCart();
      }
      else{
        $('.product-form__submit').trigger('click');
      }
    });
    
    $('.custom-buy-now-btn').click(function(e){
      e.preventDefault();
      if (popup_cart_options.length == 0){
        window.show_cart_popup_again =  false;
      }
      if(popup_cart_options.length || window.show_cart_popup_again ){

        $('.modal.cart-form-modal').addClass("show-modal");
        $('body').addClass('no-scroll');

        $('.cart-form-modal .product-form__buttons .popup-add-to-cart').hide();
        $('.cart-form-modal .product-form__buttons .popup-buy-now').show();
      }
      else{
        $('.shopify-payment-button__button').trigger('click');
        $(this).attr('disabled','disabled');
        $(this).addClass('loading');
      }
    });

    $('.cart-form-modal .close-button').click(function(){
      if(!single_varaint_product_outofstock){
        window.show_cart_popup_again = true;
        $('.product-form__submit').prop('disabled', false);
        $('.custom-buy-now-btn').removeClass('hidden');
        $('.product-form__submit_mobile').html('Add to cart');
        $('.product-form__submit_mobile').attr('disabled', false);
      }
    });

  $("span.video_badge").click(function(event){
    $(this).siblings('button').trigger('click');
  });

  const toggleFlashSaleconfirmModal = ()=>{
    let modal_repalce_flash_sale = document.querySelector(".replace-item-flash-sale");
    modal_repalce_flash_sale.classList.toggle("show-modal");
    $('body').toggleClass("no-scroll");
  }

  const toggleFlashSaleWarningModal = ()=>{
    let modal_warning_flash_sale = document.querySelector(".warning-item-flash-sale");
    modal_warning_flash_sale.classList.toggle("show-modal");
    $('body').toggleClass("no-scroll");
  }

  const toggleFlashSaleWarningQunatityModal = ()=>{
    let modal_warning_flash_sale_quantity = document.querySelector(".warning-flash-sale-quantity");
    modal_warning_flash_sale_quantity.classList.toggle("show-modal");
    $('body').toggleClass("no-scroll");
  }
$(".flash-sale-qty-warning-close").click(function(e){
  toggleFlashSaleWarningQunatityModal();
})

$(".flash-sale-warning-close").click(function(e){
  e.preventDefault();
  toggleFlashSaleWarningModal();
})

  $(".falsh-sale-replace-confirm").click(function(event){
    event.preventDefault();
    window.replaceFlashSaleItem = true;
    window.flashSaleAlertShow = true;
    toggleFlashSaleconfirmModal(); 
    if(window.showVaraintPopup ==  true && (window.show_cart_popup_again || popup_cart_options.length)){
      toggleModalCart();
      return;
    }
    if(popup_cart_options.length ==0){
      document.querySelector('product-form form').dispatchEvent(new Event("submit"));
    }
    
  });

  $(".falsh-sale-replace-close").click(function(event){
    event.preventDefault();
    toggleFlashSaleconfirmModal();
  })

  $("quantity-input .flash-sale-item").click(function(event){
    event.preventDefault();
    toggleFlashSaleWarningQunatityModal();
  })
}